<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding h-full"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">
        <!-- Header -->
        <div
          class="header-sidebar flex items-center"
          style="justify-content: center"
          slot="header"
        >
          <!-- Logo -->
          <router-link
            tag="div"
            class="vx-logo cursor-pointer flex items-center"
            to="/"
          >
            <!-- <logo class="w-10 mr-4 fill-current" />
            <span
              class="vx-logo-text"
              v-show="isMouseEnter || !reduce"
              v-if="title"
              >{{ title }}</span
            > -->
            <img
              v-if="isMouseEnter || !reduce"
              class="mr-4"
              src="@/assets/images/logo/getboarded-logo.svg"
              width="180px"
            />
            <img
              v-else
              src="@/assets/images/logo/gtbrdd-square.jpeg"
              width="62px"
            />
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon
                icon="XIcon"
                class="m-0 cursor-pointer"
                @click="
                  $store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                "
              />
            </template>

            <!-- Toggle Buttons -->
            <!-- <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />
            </template> -->
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <div
          class="my-5 mb-base"
          :class="{
            'mx-5': isMouseEnter || !reduce,
            'mx-3': !(isMouseEnter || !reduce),
          }"
        >
          <v-nav-menu-item
            v-if="$route.name === 'my-organizations'"
            class="org-switch-nav-item"
            to="/user/dashboard"
            routeName="user-home"
            icon="business"
            iconPack="material-icons"
            :featherIcon="false"
            slug="organization-dashboard-switch"
          >
            <span
              v-show="!verticalNavMenuItemsMin && (isMouseEnter || !reduce)"
              class="truncate py-3"
              >Switch to User</span
            >
            <vs-icon
              v-show="isMouseEnter || !reduce"
              class="ml-auto"
              color="white"
              size="20px"
              icon-pack="material-icons"
              icon="unfold_more"
            />
            <!-- <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip> -->
          </v-nav-menu-item>
          <v-nav-menu-item
            v-else
            class="org-switch-nav-item"
            to="/organization/my-organizations"
            routeName="my-organizations"
            icon="business"
            iconPack="material-icons"
            :featherIcon="false"
            slug="organization-dashboard-switch"
          >
            <span
              v-show="!verticalNavMenuItemsMin && (isMouseEnter || !reduce)"
              class="truncate py-3"
              >My Organizations</span
            >
            <!-- <vs-icon class="ml-auto" color="white" size="20px" icon-pack="material-icons" icon="unfold_more" /> -->
            <!-- <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip> -->
          </v-nav-menu-item>
        </div>

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
        >
          <div v-if="!($route.name === 'my-organizations')">
            <template v-for="(item, index) in menuItemsUpdated">
              <!-- Group Header -->
              <span
                v-if="item.header && !verticalNavMenuItemsMin"
                class="navigation-header truncate"
                :key="`header-${index}`"
              >
                {{ item.header }}
              </span>
              <!-- /Group Header -->

              <template v-else-if="!item.header">
                <!-- Nav-Item -->
                <v-nav-menu-item
                  class="org-nav-item"
                  v-if="!item.submenu"
                  :key="`item-${index}`"
                  :index="index"
                  :to="item.slug !== 'external' ? item.url : null"
                  :href="item.slug === 'external' ? item.url : null"
                  :icon="item.icon"
                  :target="item.target"
                  :isDisabled="item.isDisabled"
                  :slug="item.slug"
                  :routeName="item.routeName"
                  :isVerticalNavReduced="isMouseEnter || !reduce"
                >
                  <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                    item.name
                  }}</span>
                  <vs-chip
                    class="ml-auto"
                    :color="item.tagColor"
                    v-if="item.tag && (isMouseEnter || !reduce)"
                    >{{ item.tag }}</vs-chip
                  >
                  <vs-button
                    class="mx-2 alpha-icon flex"
                    style="padding: 5px 10px"
                    :style="{ background: item.tagColor }"
                    v-if="item.alpha"
                  >
                    <div style="color: white">Beta</div>
                  </vs-button>
                </v-nav-menu-item>

                <!-- Nav-Group -->
                <template v-else>
                  <v-nav-menu-group
                    :key="`group-${index}`"
                    :openHover="openGroupHover"
                    :group="item"
                    :groupIndex="index"
                    :open="isGroupActive(item)"
                  />
                </template>
                <!-- /Nav-Group -->
              </template>
            </template>
          </div>
        </component>
        <!-- /Menu Items -->

        <!-- T & C, Privacy Policy -->
        <hr v-if="!reduce" style="border-top: rgb(244, 246, 251)" />
        <div v-if="!reduce" class="sidebar-footer p-5" style="">
          <div class="sidebar-footer--item">
            <small><a href="/privacy-policy" target="_blank">Privacy</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/terms-of-use" target="_blank">T&C</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/gdpr-compliance" target="_blank">GDPR</a></small>
            <vs-icon
              class="mx-2"
              size="9px"
              icon="fiber_manual_record"
            ></vs-icon>
            <small><a href="/cookie-policy" target="_blank">Cookies</a></small>
          </div>
        </div>
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"
    />
    <!-- /Swipe Gesture -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";

import Logo from "../../Logo.vue";

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    title: { type: String },
  },
  data: () => ({
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true,
    },
    showShadowBottom: false,
  }),
  computed: {
    isGroupActive() {
      return (item) => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice();

      for (let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex((ix) => ix.header === item.header);
          for (let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }

      return clone;
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      },
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      },
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  watch: {
    $route(newVal) {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // if(newVal.name.includes('org-')) {
      //   this.$vs.theme({
      //     primary: this.orgData.primaryThemeColor ? this.orgData.primaryThemeColor : '#F2C244' // my new color
      //   });
      //   this.$store.commit('UPDATE_PRIMARY_COLOR', this.orgData.primaryThemeColor?this.orgData.primaryThemeColor : '#F2C244')
      // } else {
      //   this.$vs.theme({
      //     primary: '#F2C244'
      //   });
      // }
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 1200
        ? "no-nav-menu"
        : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
    orgData(newVal) {
      // if(newVal && this.$route.name.includes('org-')) {
      //   this.$vs.theme({
      //     primary: newVal.primaryThemeColor !== undefined ? newVal.primaryThemeColor : '#F2C244' // my new color
      //   });
      //   this.$store.commit('UPDATE_PRIMARY_COLOR', newVal.primaryThemeColor?newVal.primaryThemeColor : '#F2C244')
      // } else {
      //   this.$vs.theme({
      //     primary: '#F2C244'
      //   });
      // }
    },
  },
  methods: {
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false;
    },
    mouseEnter() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
      this.isMouseEnter = true;
    },
    mouseLeave() {
      if (this.reduce)
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
      this.isMouseEnter = false;
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);

      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
  beforeDestroy() {
    this.toggleReduce(false);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";

.org-nav-item.vs-sidebar-item-active .router-link-active {
  background: none !important;
  box-shadow: none !important;
}

.org-nav-item.vs-sidebar--item .router-link-active {
  background: none !important;
  box-shadow: none !important;
}

.vs-sidebar-primary .vs-sidebar-item-active {
  background: none !important;
}

.org-switch-nav-item.vs-sidebar--item {
  background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  // margin: 0 25px;
  // padding: 0!important;
}

.org-switch-nav-item.vs-sidebar--item span {
  color: white;
}

.org-nav-item.vs-sidebar-item-active .router-link-active span {
  color: rgba(var(--vs-primary, "#F2C244"), 1) !important;
}
.org-nav-item.vs-sidebar--item .router-link-active span {
  color: rgba(var(--vs-primary, "#F2C244"), 1) !important;
}

.v-nav-menu .scroll-area-v-nav-menu {
  max-height: calc(var(--vh, 1vh) * 100 - 250px) !important;
}

.sidebar-footer {
  position: absolute;
  bottom: 0;
}

.sidebar-footer--item {
  display: flex;
  align-items: center;
  color: #a9a9a9 !important;
}

.sidebar-footer--item a {
  color: #a9a9a9 !important;
}

.vs-sidebar.vs-sidebar-reduce .vs-sidebar--item i {
  padding: 0 !important;
}
.alpha-icon div {
  font-size: 12px !important;
}
</style>
